// Selfie Feedback Callbacks for Mitek/MiSnap ID-Verify

// Developer Note:
//  This functionality is brought over from Legacy however is not currently in use
//  Commenting them here for the expected future implementation

import FeedbackMap from './FeedbackKeys';

// const enableFaceInGuide = () => {
//     document
//         .getElementsByClassName('integrator SELFIE')[0]
//         .classList.add('FACE_IN_GUIDE');
// };

// const disableFaceInGuide = () => {
//     document
//         .getElementsByClassName('integrator SELFIE')[0]
//         .classList.remove('FACE_IN_GUIDE');
// };

// const DefaultSelfieFeedback: FeedbackMap = {
//     MISNAP_SMILE: enableFaceInGuide,
//     MISNAP_STOP_SMILING: enableFaceInGuide,
//     MISNAP_READY_POST: enableFaceInGuide,
//     default: disableFaceInGuide,
// } as const;

// export default DefaultSelfieFeedback;

// Filler to prevent Webpack from failing the build

const DefaultSelfieFeedback: FeedbackMap = {
    MISNAP_SMILE: 'Selfie Not Implemented',
    MISNAP_STOP_SMILING: 'Selfie Not Implemented',
    MISNAP_READY_POST: 'Selfie Not Implemented',
    default: 'Selfie Not Implemented',
} as const;

export default DefaultSelfieFeedback;